/*! HPN Volldeklaration
    Gehört zu sections/hpn-volldeklaration.liquid.

    Das Skript hat genau drei Aufgaben. Fällt es aus, bleibt die Section
    vollständig bedienbar: die Tabelle ist lesbar, das Akkordeon klappt
    (natives details mit name-Attribut, ohne JavaScript exklusiv), nur die
    Inhaltsliste links fehlt.

    1. Tabelle veredeln. Die eingefügte Tabelle kommt unverändert von der
       Live-Seite. Alles, was der Entwurf zeigt, ist daraus ableitbar,
       nachgemessen über alle 535 Datenzeilen im Bestand:
         Gruppenzeile   eine Zelle mit colspan
         davon-Zeile    erste Zelle beginnt mit "davon"       (64 von 64 gleich)
         Zusatz         Klammer am Ende des Namens            (86 Zeilen)
       Zahlen und Zeichen (%, **, *, Kreuze, Gramm) bleiben unangetastet
       stehen. Die Section schreibt Inhalte NICHT um, das ist Beschluss.

       Die NRV-Balken sind am 2026-08-16 wieder rausgeflogen. Begründung
       Sami: Kunden arbeiten visuell, und ein Balken liest sich als
       Fortschritt. Bei Magnesium mit 32 Prozent hätte er gegen das Produkt
       gearbeitet, obwohl die Dosierung Absicht ist. Der Akzent kommt
       stattdessen an einer anderen Stelle ins Design.

    2. Inhaltsliste links bauen und den aktiven Punkt markieren.

    3. Rückfallebene für Browser ohne details[name].
*/
(function () {
  'use strict';

  var SANFT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Derselbe Umschaltpunkt wie im Stylesheet, ab dem die Inhaltsliste erscheint.
  var DESKTOP = window.matchMedia('(min-width: 901px)');
  var NATIV_EXKLUSIV = 'name' in document.createElement('details');

  function text(el) {
    return (el && el.textContent ? el.textContent : '').trim();
  }

  /* ---- 1. Tabelle veredeln --------------------------------------------- */

  function zusatzAbtrennen(zelle) {
    var roh = text(zelle);
    var treffer = roh.match(/^(.+?)\s*\(([^()]+)\)$/);
    if (!treffer) return;
    zelle.textContent = treffer[1];
    var klein = document.createElement('small');
    klein.className = 'hpn-vd__zusatz';
    klein.textContent = treffer[2];
    zelle.appendChild(klein);
  }

  function tabelleVeredeln(tabelle) {
    if (tabelle.dataset.vdFertig) return;
    tabelle.dataset.vdFertig = '1';

    var spalten = [].map.call(tabelle.querySelectorAll('thead th'), text);

    // Ab vier Spalten stünden mobil sonst zwei nackte Zahlen nebeneinander
    // und niemand wüsste, welche wofür gilt.
    if (spalten.length > 3) tabelle.classList.add('hpn-vd__tabelle--breit');

    [].forEach.call(tabelle.querySelectorAll('tbody tr'), function (zeile) {
      var zellen = zeile.cells;
      if (!zellen || !zellen.length) return;

      if (zellen.length === 1 && zellen[0].colSpan > 1) {
        zeile.classList.add('hpn-vd__gruppe');
        // Einzige Gruppe mit Farbakzent. Erkannt am Namen und nicht an der
        // Position, weil "erste Gruppe" auf Vorlagen ohne Markenrohstoffe
        // die falsche Zeile treffen würde. Umsortiert wird in der Vorlage,
        // das Skript ordnet nichts um.
        if (/^\s*Markenrohstoffe?\b/i.test(text(zellen[0]))) {
          zeile.classList.add('hpn-vd__gruppe--marken');
        }
        return;
      }

      // Untergliederung. Im Bestand gemessen: 70 mal schlicht "davon",
      // 4 mal mit Pfeil davor, 3 mal mit Strich, einmal "entspricht".
      // Der Text selbst bleibt stehen, nur eingerückt wird er.
      if (/^\s*(?:[→–—>\-•]\s*)?(?:davon|entspricht|hiervon)\b/i.test(text(zellen[0]))) {
        zeile.classList.add('hpn-vd__davon');
      } else {
        zusatzAbtrennen(zellen[0]);
      }

      for (var i = 1; i < zellen.length; i++) {
        if (spalten[i]) zellen[i].setAttribute('data-vd-spalte', spalten[i]);
      }
    });
  }

  /* ---- 2. Inhaltsliste -------------------------------------------------- */

  function hinspringen(ziel) {
    if (!ziel.scrollIntoView) return;
    ziel.scrollIntoView({ behavior: SANFT ? 'auto' : 'smooth', block: 'start' });
  }

  function aufklappen(punkt) {
    if (punkt.tagName === 'DETAILS') punkt.open = true;
  }

  /* Immer nur einer offen. Steht bewusst als eigene Funktion da und wird vom
     Klick auf die Inhaltsliste SYNCHRON aufgerufen, bevor gesprungen wird.

     Sonst springt die Seite zu weit: das toggle-Ereignis von details feuert
     asynchron. Der Sprung würde also noch mit der alten, um die aufgeklappte
     Zusammensetzung längeren Seite rechnen, und danach klappt sie zu und
     alles rutscht um rund 2000 Pixel nach oben. Man landet bei den
     Kundenbewertungen. Genau das ist am 2026-08-16 passiert. */
  function nurDiesenOffen(klappen, klappe) {
    [].forEach.call(klappen, function (andere) {
      if (andere === klappe) return;
      // Mobil bleibt die Zusammensetzung stehen, dort gibt es keine
      // Inhaltsliste, über die man sie zurückholen könnte.
      if (!DESKTOP.matches && andere.hasAttribute('data-vd-haupt')) return;
      andere.open = false;
    });
  }

  function markieren(wurzel, liste) {
    var offen = wurzel.querySelectorAll('details[data-vd-titel][open]');
    var aktiv = offen.length ? offen[offen.length - 1] : wurzel.querySelector('[data-vd-haupt]');
    [].forEach.call(liste.querySelectorAll('a'), function (a) {
      if (aktiv && a.getAttribute('href') === '#' + aktiv.id) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  function listeBauen(wurzel, klappen) {
    var liste = wurzel.querySelector('[data-vd-liste]');
    if (!liste || liste.children.length) return null;

    var punkte = wurzel.querySelectorAll('[data-vd-titel]');
    // Eine Liste mit einem einzigen Eintrag ist keine Liste.
    if (punkte.length < 2) return null;

    [].forEach.call(punkte, function (punkt) {
      if (!punkt.id) return;
      var a = document.createElement('a');
      a.href = '#' + punkt.id;
      a.textContent = punkt.getAttribute('data-vd-titel');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        aufklappen(punkt);
        nurDiesenOffen(klappen, punkt);
        hinspringen(punkt);
      });
      liste.appendChild(a);
    });

    liste.hidden = false;
    // Erst jetzt entsteht die zweispaltige Rinne. Ohne Skript stünde dort
    // sonst eine leere 250-Pixel-Spalte.
    wurzel.classList.add('hpn-vd--mit-liste');
    return liste;
  }

  /* ---- 3. Rückfallebene und Start --------------------------------------- */

  function starten(wurzel) {
    if (wurzel.dataset.vdBereit) return;
    wurzel.dataset.vdBereit = '1';

    [].forEach.call(wurzel.querySelectorAll('.hpn-vd__tabelle-bereich table'), tabelleVeredeln);

    var klappen = wurzel.querySelectorAll('details[data-vd-titel]');
    var liste = listeBauen(wurzel, klappen);

    [].forEach.call(klappen, function (klappe) {
      klappe.addEventListener('toggle', function () {
        if (!klappe.open) {
          if (liste) markieren(wurzel, liste);
          return;
        }

        if (DESKTOP.matches || !NATIV_EXKLUSIV) nurDiesenOffen(klappen, klappe);

        if (liste) markieren(wurzel, liste);
      });
    });

    // Mobil ist die Zusammensetzung kein Akkordeon, sondern steht fest offen.
    // Beschluss Sami: die Tabelle ist das Argument der Seite, und mobil gibt
    // es keine Inhaltsliste, über die man sie zurückholen könnte.
    var haupt = wurzel.querySelector('details[data-vd-haupt]');
    function haupPflegen() {
      if (!haupt) return;
      if (DESKTOP.matches) {
        wurzel.classList.remove('hpn-vd--haupt-fest');
      } else {
        haupt.open = true;
        wurzel.classList.add('hpn-vd--haupt-fest');
      }
    }
    haupPflegen();
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', haupPflegen);
    else if (DESKTOP.addListener) DESKTOP.addListener(haupPflegen);

    if (liste) markieren(wurzel, liste);
  }

  function alle() {
    [].forEach.call(document.querySelectorAll('[data-hpn-vd]'), starten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  // Der Theme-Editor baut Sections beim Bearbeiten neu auf.
  document.addEventListener('shopify:section:load', function (e) {
    var wurzel = e.target && e.target.querySelector ? e.target.querySelector('[data-hpn-vd]') : null;
    if (wurzel) starten(wurzel);
  });
})();
